import React, { useState, useContext } from "react";
import ShopItemComponent from '../components/ShopItemComponent';
import { GameContext } from '../context/GameContext';

interface ShopItem {
    id: number;
    price: number;
    image: string;
    name: string;
    position: {
        top: string;    // e.g., '16%'
        left: string;   // e.g., '45%'
        width: string;  // e.g., '290px'
        height: string; // e.g., '450px'
    };
}

const storeItems: ShopItem[] = [
    {
        id: 1,
        price: 150,
        image: '/store/urn.png',
        name: "Ancient Urn",
        position: {
            top: '16%',
            left: '45%',
            width: '290px',
            height: '450px'
        }
    },
    {
        id: 2,
        price: 100,
        image: '/store/helmet.png',
        name: "Helmet",
        position: {
            top: '41%',
            left: '23%',
            width: '270px',
            height: '270px'
        }
    },
    {
        id: 3,
        price: 15,
        image: '/store/laurel.png',
        name: "laurel",
        position: {
            top: '21%',
            left: '28.5%',
            width: '100px',
            height: '100px'
        }
    },
    {
        id: 4,
        price: 75,
        image: '/store/Lyre.png',
        name: "Lyre",
        position: {
            top: '4.5%',
            left: '33%',
            width: '210px',
            height: '210px'
        }
    },
    {
        id: 5,
        price: 25,
        image: '/store/MagicPotions.png',
        name: "Potions",
        position: {
            top: '52%',
            left: '11%',
            width: '220px',
            height: '220px'
        }
    },
    {
        id: 6,
        price: 20,
        image: '/store/MagicSapphire.png',
        name: "Helmet",
        position: {
            top: '60%',
            left: '68%',
            width: '100px',
            height: '100px'
        }
    },
    {
        id: 7,
        price: 120,
        image: '/store/goldenowl.png',
        name: "Golden Owl",
        position: {
            top: '9%',
            left: '13%',
            width: '150px',
            height: '150px'
        }
    },
    {
        id: 8,
        price: 100,
        image: '/store/cupidsquiver.png',
        name: "Quiver",
        position: {
            top: '38%',
            left: '73%',
            width: '280px',
            height: '280px'
        }
    },
    {
        id: 9,
        price: 8,
        image: '/store/cupidsbow.png',
        name: "Bow",
        position: {
            top: '9%',
            left: '65%',
            width: '300px',
            height: '300px'
        }
    }
];

const StoreRoom: React.FC = () => {
    const { score, purchasedItems, purchaseItem } = useContext(GameContext)!; // Use context
    const [showAlert, setShowAlert] = useState(false);

    const handleBuy = (id: number) => {
        const item = storeItems.find(item => item.id === id);
        if (item && score >= item.price && !purchasedItems.find(p => p.id === id)) {
            if (purchasedItems.length >= 4) {
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 3000);
                return;
            }
            purchaseItem(item); // Use context's purchaseItem
        }
    };

    return (
        <div className="min-w-[1440px] min-h-[810px] w-screen h-screen overflow-hidden relative" style={{
            backgroundImage: "url('/images/shop.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}>
            <div className="absolute top-[10%] left-10 bg-white p-2 rounded shadow">
                <span className="text-xl font-bold">Coins: {score}</span>
            </div>
            {storeItems.map(item => (
                !purchasedItems.find(p => p.id === item.id) && (
                    <ShopItemComponent
                        key={item.id}
                        item={item}
                        currentCoins={score} // Use context's score
                        onBuy={() => handleBuy(item.id)} // Updated to pass item.id
                    />
                )
            ))}
            {showAlert && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="bg-black/80 text-white px-6 py-4 rounded-lg shadow-lg">
                        <p className="text-xl font-cinzel">
                            Cannot purchase more items - Trophy limit of 4 reached!
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default StoreRoom;